import { gql } from '@apollo/client';

export const ALL_TEMPLATE_TYPES = gql`
  query AllTemplateTypes {
    templateTypes: getTemplateTypes {
      id
      name
    }
  }
`;
